<template>
    <div class="col-lg-9">
        <!-- Navigation Tabs -->
        <div class="custom-nav-container mb-3">
            <h4 class="text-7">Business Settings</h4>
            <ul class="custom-nav-tabs">
                <li class="custom-nav-item">
                    <router-link
                        to="/business/settings/business-details"
                        class="custom-nav-link"
                        exact
                    >
                        Business
                    </router-link>
                </li>
                <li class="custom-nav-item">
                    <router-link
                        to="/business/settings/biller-settings"
                        class="custom-nav-link"
                        exact
                    >
                        Biller
                    </router-link>
                </li>
                <li class="custom-nav-item">
                    <router-link
                        to="/business/settings/banking-details"
                        class="custom-nav-link"
                        exact
                    >
                        Banking
                    </router-link>
                </li>
                <li class="custom-nav-item">
                    <router-link
                        to="/business/settings/business-documents"
                        class="custom-nav-link"
                        exact
                    >
                        Documents
                    </router-link>
                </li>
                <li class="custom-nav-item">
                    <router-link
                        to="/business/settings/authorized-individuals"
                        class="custom-nav-link"
                        exact
                    >
                        Authorized Individuals
                    </router-link>
                </li>
            </ul>
            <div class="custom-nav-underline">
                <div class="custom-nav-active-underline" :style="{ left: activeTabPosition, width: activeTabWidth }"></div>
            </div>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: "Settings",
    data() {
        return {
            activeTabPosition: "0px",
            activeTabWidth: "0px",
        };
    },
    mounted() {
        this.updateActiveTabPosition();
    },
    methods: {
        updateActiveTabPosition() {
            this.$nextTick(() => {
                const activeTab = document.querySelector(".custom-nav-tabs .custom-nav-link.active, .custom-nav-tabs .custom-nav-link.router-link-exact-active");
                if (activeTab) {
                    this.activeTabPosition = `${activeTab.offsetLeft}px`;
                    this.activeTabWidth = `${activeTab.offsetWidth}px`;
                }
            });
        },
    },
    watch: {
        "$route.path": function () {
            this.updateActiveTabPosition();
        },
    },
};
</script>

<style scoped>
.custom-nav-tabs {
    display: flex;
    justify-content: flex-start;
    width: 100%;
    border-bottom: none;
    padding-left: 0 !important;
    margin-left: 0 !important;
    margin-bottom: 0 !important;
}
.custom-nav-item {
    /* Optional: add spacing if needed */
}
.custom-nav-link {
    display: block;
    padding: 0.5rem 1rem;
    text-decoration: none;
    color: #333;
    transition: color 0.3s;
}
.custom-nav-link.router-link-exact-active,
.custom-nav-link.active {
    color: #252C65;
}
.custom-nav-underline {
    position: relative;
    width: 100%;
    height: 1px;
    background-color: #ddd;
    margin-top: -2px;
}
.custom-nav-active-underline {
    position: absolute;
    bottom: 0;
    height: 2px;
    background-color: #252C65;
    transition: left 0.3s, width 0.3s;
}
</style>
